import React from 'react';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Grid from '@material-ui/core/Grid';
import {Styles} from '../../../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from '../../../../../config/Translate';
import validator from 'validator';
import axios from 'axios';
import { defaultVariabls } from '../../../../../config/index';
import { withRouter} from "react-router";
import {withSnackbar} from "notistack";
import LoadingButton from "../../../../components/elements/LoadingButton";
import {connect} from "trim-redux";
import AppCardLoaderFields from "../../../../components/Skeletons/AppCardLoaderFields";
import {secret} from "../../../../../config/Security";
import MenuItem from "@material-ui/core/MenuItem/MenuItem";
import {rolesWithName} from '../../../../../config/Permissions'
class AddUser extends React.Component {
    classes = this.props.classes
    state={
        fields: {
            name: '',
            email:'',
            role:'user',
            password:'',
            password_confirmation: '',
        },
        errors:{},
        loading:false,
        SubmitLoading:false
    };
    handleChange(e){
        let {fields,errors} = this.state;
        let target = e.target;
        errors[target.name] = "";
        fields[target.name] = target.value;
        this.setState({
            fields,

        });
    }
    handleValidation(callback){
        let { fields } = this.state;
        let errors = {};
        let formIsValid = true;


        //Email
        if(validator.isEmpty(fields.email)){
            formIsValid = false;
            errors['email'] = Translate.emptyEmail;
        }else if(!validator.isEmail(fields.email)){
            formIsValid = false;
            errors['email'] = Translate.wrongEmail;
        }


        //Password
        if(validator.isEmpty(fields.password)){
            formIsValid = false;
            errors['password'] = Translate.emptyPassword;
        }else if(fields.password.length < 6){
            formIsValid = false;
            errors['password'] = Translate.weakPassword;
        }

        //check Email and Mobile
        let data = new FormData();
        data.append('email', fields.email);
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        const request = async () => {
            if(errors['email'] === undefined){
                await axios.post(`${defaultVariabls.url}/register/checkEmail`, data, config)
                    .then(response => {}).catch(error => {
                        formIsValid = false;
                        errors['email'] = Translate.existEmail;
                    });
            }
            await this.setState({errors},() =>{
                if(!formIsValid){
                    this.props.enqueueSnackbar(Translate.someFieldsHasError, {
                        variant: 'warning',
                    });
                    this.setState({
                        SubmitLoading:false
                    })
                }
                return callback(formIsValid)
            });
        }
        request();
    }
    handleRequest(){
        const {fields} = this.state;
        let data = new FormData();
        data.append('secret', secret);
        data.append('email', fields.email);
        data.append('name', fields.name);
        data.append('password', fields.password);
        data.append('password_confirmation', fields.password_confirmation);
        data.append('role', fields.role);
        let loginToken = localStorage.getItem('ACT');
        let config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };
        axios.post(`${defaultVariabls.url}/user/make/`, data, config)
            .then(response => {
                this.props.enqueueSnackbar(Translate.detailsSet, {
                    variant: 'success',
                });
                this.setState({
                    SubmitLoading:false
                });
                this.props.history.push(`/manage/users/view/all`);
            })
            .catch(error => {
                this.props.enqueueSnackbar(Translate.detailsSetFailed, {
                    variant: 'error',
                });
            });
    }
    handleSubmit(e){
        this.setState({
            SubmitLoading:true
        });
        e.preventDefault();
        this.handleValidation((valid) =>{
            if(valid) {
                this.handleRequest();
            }

        });
    }
    render() {
        const {errors,fields,SubmitLoading} = this.state;
        if (this.state.loading) {
            return (
                <AppCardLoaderFields/>
            )
        } else {
            return (
                <React.Fragment>
                    <Grid container  spacing={2} justify="center" alignItems="center">
                        <CssBaseline/>
                        <Grid item xs={12} md={5}>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                value={fields.name}
                                fullWidth
                                id="name"
                                label={Translate.userName}
                                name="name"
                                onChange={this.handleChange.bind(this)}
                                error = {!!errors['name']}
                                helperText={errors['name']}
                            />
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <TextField
                                variant="outlined"
                                margin="normal"
                                required
                                value={fields.email}
                                fullWidth
                                id="email"
                                label={Translate.email}
                                name="email"
                                autoComplete="email"
                                onChange={this.handleChange.bind(this)}
                                error = {!!errors['email']}
                                helperText={errors['email']}
                            />
                        </Grid>
                        <Grid item xs={12} md={10}>
                            <TextField
                                select
                                fullWidth
                                variant="outlined"
                                margin="normal"
                                required
                                value={fields.role}
                                name="role"
                                id="role"
                                helperText={Translate.roleHelper}
                                onChange={this.handleChange.bind(this)}
                                >
                                    {
                                        rolesWithName.map((row,key) => (
                                            <MenuItem value={row.value} key={key}>
                                                {row.name}
                                            </MenuItem>
                                        ))
                                    }
                            </TextField>
                        </Grid>
                        <Grid item xs={12} md={5}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                name="password"
                                label={Translate.password}
                                type="password"
                                id="password"
                                onChange={this.handleChange.bind(this)}
                                autoComplete="current-password"
                                error={!!errors['password']}
                                helperText={errors['password']}
                            />

                        </Grid>
                        <Grid item xs={12} md={5}>
                            <TextField
                                variant="outlined"
                                required
                                fullWidth
                                name="password_confirmation"
                                label={Translate.passwordConfirm}
                                type="password"
                                id="password_confirmation"
                                onChange={this.handleChange.bind(this)}
                                autoComplete="current-password"
                                error={!!errors['password_confirmation']}
                                helperText={errors['password_confirmation']}
                            />
                        </Grid>
                        <Grid item xs={12}>
                        <LoadingButton
                            variant="contained"
                            color="primary"
                            onClick = {this.handleSubmit.bind(this)}
                            loading = {SubmitLoading}
                        >
                            {Translate.setDetails}
                        </LoadingButton>
                        </Grid>
                    </Grid>
                </React.Fragment>
            );
        }
    }
}
const mstp = state => ({
    isAuth: state.isAuth,
    user: state.user
});
export default withRouter(withSnackbar(withStyles(Styles)(connect(mstp)(AddUser))));